import { autoserialize } from 'cerialize';

export class StandardDonationMeta implements IStandardDonationMeta {
  @autoserialize smsApproval?: boolean;
  @autoserialize manualAddress?: boolean;
  @autoserialize donation_items_user?: string;

  constructor(payload?: IStandardDonationMeta) {
    this.smsApproval = payload?.smsApproval;
    this.manualAddress = payload?.manualAddress;
    this.donation_items_user = payload?.donation_items_user;
  }
}

export interface IStandardDonationMeta {
  smsApproval?: boolean;
  manualAddress?: boolean;
  donation_items_user?: string;
}
